import { AutomationRuleTriggerFilterInterface } from 'modules/automation-rules/triggers/types/automation-rule-trigger-filter-interface'

export const defaultTriggerFilters: AutomationRuleTriggerFilterInterface = {
  triggerTagId: undefined,
  triggerCourseBundleId: undefined,
  triggerCourseId: undefined,
  triggerCommunityId: undefined,
  triggerLectureId: undefined,
  triggerLinkClickedId: undefined,
  triggerMailingId: undefined,
  triggerModuleId: undefined,
  triggerCampaignId: undefined,
  triggerDigitalStoreId: undefined,
  triggerDigitalStoreOptInId: undefined,
  blogEntity: undefined,
  blogId: undefined,
  blogPageEntityId: undefined,
  blogPostEntityId: undefined,
  cancelSaleFunnelId: undefined,
  cancelSaleFunnelStepId: undefined,
  formSubscribeFunnelId: undefined,
  formSubscribeFunnelStepId: undefined,
  newSaleFunnelId: undefined,
  newSaleFunnelStepId: undefined,
  pageVisitedFunnelId: undefined,
  pageVisitedFunnelStepId: undefined,
  subscriptionFailedFunnelId: undefined,
  subscriptionFailedFunnelStepId: undefined,
  webinarFunnelId: undefined,
  webinarId: undefined,
  triggerWebsiteId: undefined,
  triggerWebsitePageId: undefined,
}
